<template>
    <uni-button :disabled="isDisable">
        <div v-if="isDisable">
            <uni-circular-loader/>
        </div>
        <div v-else>
            {{ text }}
        </div>
    </uni-button>
</template>

<script>
    import UniButton from "../a-elements/UniButton";
    import UniCircularLoader from "../a-elements/UniCircularLoader";

    export default {
        name: "UniLoadingButton",
        components: {UniCircularLoader, UniButton},
        props: {
            isDisable: Boolean,
            text: String,
        }
    }
</script>

<style scoped lang="scss">
    button.uni-button {
        padding: 0 var(--s-l);
        height: 54px;
        width: 100%;
    }

    button /deep/ .loader {
        height: 24px;
        width: 24px;
    }

    @include screen-m {
        button.uni-button {
            width: auto;
        }
    }
</style>
